(function () {
  function initializeGallery(gallery) {
    if (gallery.dataset.vmxGalleryV2 === 'true') return;

    var thumbnails = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list .thumbnail')
    );
    if (!thumbnails.length) return;

    gallery.dataset.vmxGalleryV2 = 'true';
    gallery.querySelectorAll('.vmx-gallery-arrow').forEach(function (button) {
      button.remove();
    });

    if (thumbnails.length < 2) return;

    var previous = document.createElement('button');
    var next = document.createElement('button');

    previous.type = 'button';
    next.type = 'button';
    previous.className = 'vmx-gallery-arrow vmx-gallery-arrow--prev';
    next.className = 'vmx-gallery-arrow vmx-gallery-arrow--next';
    previous.setAttribute('aria-label', 'Previous product image');
    next.setAttribute('aria-label', 'Next product image');
    previous.innerHTML = '&#8249;';
    next.innerHTML = '&#8250;';

    function activeIndex() {
      thumbnails = Array.prototype.slice.call(
        gallery.querySelectorAll('.thumbnail-list .thumbnail')
      );
      return thumbnails.findIndex(function (thumbnail) {
        return thumbnail.hasAttribute('aria-current');
      });
    }

    function updateButtons() {
      var index = activeIndex();
      if (index < 0) index = 0;
      previous.disabled = index === 0;
      next.disabled = index === thumbnails.length - 1;
    }

    function changeMedia(direction) {
      var index = activeIndex();
      if (index < 0) index = 0;
      var targetIndex = index + direction;
      if (targetIndex < 0 || targetIndex >= thumbnails.length) return;
      thumbnails[targetIndex].click();
      window.requestAnimationFrame(updateButtons);
    }

    previous.addEventListener('click', function () {
      changeMedia(-1);
    });
    next.addEventListener('click', function () {
      changeMedia(1);
    });

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        window.requestAnimationFrame(updateButtons);
      });
    });

    new MutationObserver(updateButtons).observe(gallery, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-current']
    });

    gallery.appendChild(previous);
    gallery.appendChild(next);
    updateButtons();
  }

  function initializeAll(root) {
    (root || document).querySelectorAll('media-gallery').forEach(initializeGallery);
  }

  function initializeHoverMenus(root) {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;

    (root || document)
      .querySelectorAll('.header__inline-menu details')
      .forEach(function (details) {
        if (details.dataset.vmxHoverMenu === 'true') return;
        details.dataset.vmxHoverMenu = 'true';

        var closeTimer;
        var summary = details.querySelector(':scope > summary');

        function openMenu() {
          window.clearTimeout(closeTimer);
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }

        function closeMenu() {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(function () {
            details.removeAttribute('open');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }, 140);
        }

        details.addEventListener('mouseenter', openMenu);
        details.addEventListener('mouseleave', closeMenu);
        details.addEventListener('focusin', openMenu);
        details.addEventListener('focusout', function (event) {
          if (!details.contains(event.relatedTarget)) closeMenu();
        });
      });
  }

  function initializeThemeFeatures(root) {
    initializeAll(root);
    initializeHoverMenus(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeThemeFeatures(document);
    });
  } else {
    initializeThemeFeatures(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeThemeFeatures(event.target);
  });
})();
